module.exports = __webpack_public_path__ + "img/join_img2.998609f4.jpg";